module.exports = __webpack_public_path__ + "img/newchris-42.58539513.jpg";